import {RemotePostInvoicesRecover} from 'data/usecases';
import {PostInvoicesRecover} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makePostInvoicesRecover = (): PostInvoicesRecover =>
	new RemotePostInvoicesRecover(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.invoicesRecover),
		makeAuthorizeHttpClientDecorator(),
	);
